import React from "react";
import { Button } from 'reactstrap';
class JirangoButton extends React.Component {
    state = {
        mouseOver: false
    }
    mouseEnter = () => {
        this.setState({ mouseOver: true });
    }
    mouseLeave = () => {
        this.setState({ mouseOver: false });
    }
    render() {
        const { style, children, onClick, disabled, settings } = this.props;
        let btnStyle = this.state.mouseOver && style["&:hover"] !== undefined ?
            {
                ...style,
                backgroundColor: style["&:hover"].backgroundColor,
                color: style["&:hover"].color
            } : style;
        return (
            <Button
                disabled={disabled}
                style={{ ...btnStyle, opacity: 1,/*  padding: '5px 10px', */ height: settings ? settings.style.height : 'initial', width: settings ? settings.style.width: 'auto',
                
                padding: btnStyle.padding || '4px 12px' }}
                onClick={onClick}
                onMouseEnter={this.mouseEnter}
                onMouseLeave={this.mouseLeave}
            >
                {children}
            </Button>
        );
    }

};
export default JirangoButton;
